import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getAlldevices } from "../../../../redux/apiCalls/devicesCall/devicesCall";
import { getDeviceDisplayName } from "../../utils/analysisContextUtils";

const DeviceSelector = ({ value, onChange, branchId, userToken, dispatch }) => {
  const devices = useSelector((state) => state.devices.currentDevices ?? []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userToken) return;

    const fetchDevices = async () => {
      setLoading(true);
      try {
        await getAlldevices(dispatch, userToken);
      } catch (error) {
        console.error("Error fetching devices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, [userToken, dispatch]);

  const filteredDevices = useMemo(() => {
    return devices.filter((device) => {
      if (!branchId || branchId === "all") return true;
      const branchValues = [
        device.branch_fk,
        device.branch_id,
        device.branchId,
        device.branch_office,
        device.branchOffice,
      ];
      return branchValues.some((branchValue) => String(branchValue) === String(branchId));
    });
  }, [devices, branchId]);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    if (!selectedId) {
      onChange(null);
      return;
    }

    const selected = filteredDevices.find((d) => String(d.id) === selectedId);
    if (selected) {
      onChange({
        id: selected.id,
        name: getDeviceDisplayName(selected),
        mac: selected.mac,
      });
    }
  };

  if (branchId === undefined || branchId === null) {
    return (
      <div className="selector-wrapper">
        <select className="field-select" disabled>
          <option>Seleccioná una sucursal primero</option>
        </select>
        <div className="field-hint">Debes seleccionar una sucursal para ver dispositivos</div>
      </div>
    );
  }

  return (
    <div className="selector-wrapper">
      <select
        className="field-select"
        value={value?.id || ""}
        onChange={handleChange}
        disabled={loading || filteredDevices.length === 0}
      >
        <option value="">
          {loading
            ? "Cargando dispositivos..."
            : filteredDevices.length === 0
            ? "No hay dispositivos disponibles"
            : "Seleccionar dispositivo..."}
        </option>
        {filteredDevices.map((device) => (
          <option key={device.id} value={device.id}>
            {getDeviceDisplayName(device) || `Dispositivo ${device.id}`}
          </option>
        ))}
      </select>
      {value && <div className="selected-value">{value.name}</div>}
    </div>
  );
};

export default DeviceSelector;
